import { bool, func, instanceOf } from 'prop-types'

import Locale from '../../../../../models/Locale.js'
import IconButton from '../../theme-components/icon-button.js'

function DesktopCarouselControl({ backgroundIsDark = false, leftFunc, rightFunc, locale }) {
  // @todo: this should probably correspond to the post color and match that instead
  const buttonStyles = {
    background: backgroundIsDark ? '#fff' : '#333',
    userSelect: 'none',
  }

  // @todo: this should probably correspond to the post color and match that instead
  const arrowColor = backgroundIsDark ? '#333' : '#fff'

  return (
    <div className="bzfy-c-carousel-control-wrapper">
      <IconButton
        ariaLabel={locale.getTranslation('previousPost')}
        className="bzfy-c-carousel-control"
        iconColor={arrowColor}
        iconName="arrow-left"
        onClick={leftFunc}
        style={buttonStyles}
      />
      <IconButton
        ariaLabel={locale.getTranslation('nextPost')}
        className="bzfy-c-carousel-control bzfy-c-carousel-control--right"
        iconColor={arrowColor}
        iconName="arrow-right"
        onClick={rightFunc}
        style={buttonStyles}
      />
    </div>
  )
}

DesktopCarouselControl.propTypes = {
  backgroundIsDark: bool,
  leftFunc: func.isRequired,
  locale: instanceOf(Locale).isRequired,
  rightFunc: func.isRequired,
}

export default DesktopCarouselControl
